import React, { useEffect } from 'react'
import { OnboardingType } from 'generated/types'
import CenteredSpinner from 'components/CenteredSpinner/CenteredSpinner'
import { withFlowRouter, WithFlowRouterProps } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { useOnboardingRequirements } from 'utils/FlowProvider/requirementsMapping'

const CheckingOnboarding = ({ route }: WithFlowRouterProps) => {
  const { allOnboardingRequirements, isOnboardingRequirementsLoading } = useOnboardingRequirements(
    OnboardingType.CHECKING,
  )

  useEffect(() => {
    if (!isOnboardingRequirementsLoading) {
      const state = {
        allOnboardingRequirements,
      }

      route({ from: FlowRoute.Welcome, action: 'continue', state, locationState: state })
    }
  }, [allOnboardingRequirements, isOnboardingRequirementsLoading, route])

  return <CenteredSpinner />
}

export const CheckingOnboardingWelcome = withFlowRouter<{}>(CheckingOnboarding as any)
